import React from 'react';
const IconArrowSmallDown = () => {
  return (<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M12 17.2999L19 11.4399V8.81995L12 14.6999L5 8.81995V11.4399L12 17.2999Z" fill="#2D2E2E"/>
</svg>
);
};
export default IconArrowSmallDown;